/**
 * Branding constants — single source of truth for the product's user-facing
 * identity. Everything the user sees ("CipherOps"-as-was, now "Citadel") flows
 * from these constants. To rebrand again, change this file and rebuild — no
 * search-and-replace through 80+ files.
 *
 * Lives in @cipherops/data-source because that package is already imported
 * by every consumer (server, ui, renderer). Co-locating avoids creating yet
 * another tiny workspace package.
 *
 * NOTE on internal identifiers:
 * Workspace package names (`@cipherops/*`), DB column names
 * (`cipherops_version` in exports), Docker container names, and IPC channel
 * paths (`cipherops/auth/me`) deliberately remain on `cipherops`. They are
 * developer-only — invisible to end users — and renaming them would require
 * invasive migrations + import refactors with zero user benefit. Treat
 * `cipherops` in those contexts as a historical code-name.
 *
 * Bundle file extension (`.citadel`) IS user-visible (admins export firm
 * data and see the filename) so it uses PRODUCT_CODE.
 */

/** Display name — appears in titles, sidebars, emails, PDF reports. */
export const PRODUCT_NAME = 'Citadel';

/** Lowercase machine-safe code — used in filenames, bundle extensions, paths. */
export const PRODUCT_CODE = 'citadel';
